import {Types as SearchActionTypes} from 'components/MasterSearchBar/actions';
import ReducerBuilder from 'classes/ReducerBuilder';
import * as ResourceApi from 'api/resources';
import {Types} from './actions';

const initialState = Object.freeze({
  currentPrizeId: null,
  prizeHistoriesByUserId: {},
  fetchingWinners: false,
  masterSearchResults: [],
  currentExpandedRow: null
});

export default ReducerBuilder.make(initialState)
  .forType(Types.REQUEST_PRIZE_WINNERS)
  .reduce((state, action) => {
    state.currentPrizeId = action.prizeId;
    state.prizeHistoriesByUserId = {};
    state.fetchingWinners = true;
  })
  .forType(Types.RECEIVED_WINNER_HISTORY)
  .reduce((state, action) => {
    state.prizeHistoriesByUserId[action.winnerUserId] = action.prizeHistory;
    state.fetchingWinners = false;
  })
  .forType(Types.EXPAND_ROW)
  .reduce((state, action) => {
    state.currentExpandedRow = action.row;
  })
  .forType(Types.COLLAPSE_ROW)
  .reduce((state, action) => {
    state.currentExpandedRow = null;
  })

  // for rendering MasterSearchBar results in the table below
  .forType(SearchActionTypes.SEARCH_QUERY_CHANGED)
  .reduce((state, action) => {
    state.masterSearchResults = [];
  })
  .forType(SearchActionTypes.CLEAR_SEARCH_RESULTS)
  .reduce((state, action) => {
    state.masterSearchResults = [];
  })
  .forType(SearchActionTypes.RECEIVED_SEARCH_RESULTS)
  .reduce((state, action) => {
    if (action.resourceType === ResourceApi.Types.Winner) {
      state.masterSearchResults = action.searchResults;
    }
  })
  .build();



// WEBPACK FOOTER //
// ./public/pages/MultipleWinners/reducer.js